import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const DamageInformation = () => {
  const { control } = useFormContext();
  return (
    <div>
      <div className="form-group row" style={{ marginBottom: '0' }}>
        <div className="col-sm-12">
          <label className="detail-info-label">Damage Information</label>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-6">
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.damageInformation.preExistingCondition"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="preExistingCondition"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              Evidence of pre-existing condition
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.damageInformation.customerAdvicedBefore"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="customerAdvicedBefore"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              Customer advised before wash
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.damageInformation.itemNotFound"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="itemNotFound"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              Item not found
            </label>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.damageInformation.afterMarketItem"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="afterMarketItem"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              After market non-factory item
            </label>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Controller
                name="incidentDetails.damageInformation.oldVehicle"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    id="oldVehicle"
                    className="form-check-input"
                    type="checkbox"
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                  />
                )}
              />{' '}
              Old vehicle
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DamageInformation;
